import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import moment from "moment";
import { KeyboardTimePicker } from "@material-ui/pickers";
import Typography from './Typography.jsx';
import styles from '../styles/styles.js';
const { makeStyles } = styles;

const TimePicker = (props, ref) => {
  const classes = useStyles();
  const { error, format, value, label, valueFormat, disabled, ...rest } = props;
  const stringValue = React.useMemo(() => moment(value, valueFormat), [value, valueFormat]);
  const handleChange = (dateMoment) => {
    if (!format) props.onChange(dateMoment.toDate());
    else props.onChange(dateMoment.format(format));
  }
  return (
    <div>
      <KeyboardTimePicker
        KeyboardButtonProps={{ 'aria-label': 'change date' }}
        className={ classNames(classes.date, !!error && classes.errorInput) }
        autoOk
        inputVariant={ 'outlined' }
        ampm
        {...rest}
        disabled={disabled}
        id={ 'datetime-picker' }
        format={ format || 'MM/DD/YYYY h:mm A' }
        onChange={ handleChange }
        name={ name }
        label={ label }
        ref={ref}
        value={ stringValue }/>
      {
        !!error && (
          <Typography variant={'caption'} className={classes.errorText}>
            {error}
          </Typography>
        )
      }
    </div>
  );
}

TimePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  error: PropTypes.node,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  disabled: PropTypes.bool,
};

const useStyles = makeStyles(theme => ({
  selectCard: {
    flex: 1,
    width: '100%',
    height: 56,
    backgroundColor: 'white',
    borderRadius: 4,
    boxShadow: `rgba(0,0,0,.07) 0px 0px 12px`,
  },
  dateContainer: {
    // paddingTop: theme.spacing(),
    position: 'relative',
    height: 64 - theme.spacing(2)
  },
  date: {
    width: '100%',
  },
  errorInput: {
    "& label": {
      color: 'red'
    },
    "& div.MuiInputBase-root fieldset": {
      borderColor: 'red',
    }
  },
  errorText: {
    color: 'red',
    paddingLeft: theme.spacing(2)
  }
}));

export default forwardRef(TimePicker);